export default {
  allMsg: 'Alle Nachrichten',
  systemMsg: 'Systemnachrichten',
  personMsg: 'Manuelle Nachrichten',
  unread: 'Ungelesen',
  seeDetail: 'Details anzeigen',
  read: 'Gelesen',
  replyNow: 'jetzt antworten',
  message: 'Nachricht',
  operateSuccess: 'Erfolgreich ausgeführt',
  holder: {
    searchHolder: 'Paketnummer/Bestellnummer/Artikelnummer',
  },
  addAcBuy: 'Treten Sie AcBuy Discord bei & gewinnen Sie 2000 ¥ CASH!',
  joinNow: 'Hier beitreten',
  flatActivity: 'Acbuy Black Friday Sale',
  joinNow1: 'Jetzt mitmachen',
  tips1: 'Genieße Rabatte von bis zu 70 %',
  tips2: 'Geben Sie den Code ein, um sofort Ihren ¥110 Versandcoupon zu erhalten!',
}
